import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { RouterProvider } from "react-router";
import AuthSync from "./components/auth-sync/auth-sync";
import ModalsWrapper from "./components/modals/modals-wrapper";
import { GlobalStyle } from "./index.styles";
import { store } from "./redux/store";
import { router } from "./routes/routes";

const root = ReactDOM.createRoot(
	document.getElementById("root") as HTMLElement,
);
root.render(
	<React.StrictMode>
		<Provider store={store}>
			<ModalsWrapper />
			<GlobalStyle />
			<AuthSync />
			<RouterProvider router={router} />
		</Provider>
	</React.StrictMode>,
);
